// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"77e2226f","131":"b477e7af","161":"193c9590","361":"08f52d85","479":"25950ed8","549":"6d3ff816","709":"7ac1a18f","878":"65ce4c10","970":"2b76858c","989":"f028035a","993":"e74bb11f"}[chunkId] + ".chunk.js";
};